import PeSingleChoice from '../../components/PeSingleChoice';
import AddressAutoComplete from '../../components/PeAddressFields';

export const installOpt = {
    how_many: [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
    ],
    brick_type: [
        { label: 'Brick Veneer', value: 'brick_veneer', img: 'veneer', },
        { label: 'Double Brick', value: 'double_brick', img: 'double', },
        { label: 'Weatherboard', value: 'weather_board', img: 'weather', },
        { label: 'Other', value: 'other', img: 'other', },
    ],
    storey_type: [
        { label: 'Single Storey', value: 'single_storey' },
        { label: 'Double Storey', value: 'double_storey' },
        { label: '3+ Stories', value: 'more_stories' },
    ],
    outdoor: [
        { label: 'On ground', value: 'on_ground' },
        { label: 'Low wall bracket', value: 'low_wall_bracket', subLabel: '(Single Storey)' },
        { label: 'High wall bracket', value: 'high_wall_bracket', subLabel: '(Single Storey)' },
        { label: 'On roof', value: 'on_roof' },
        { label: 'Sub roof', value: 'sub_floor' },
    ],
    circuit: [
        { label: 'EXISTING circuit that is NOT Kitchen', value: 'circuit_existing' },
        { label: 'NEW circuit', value: 'circuit_new' },
    ],
    yes_no: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
    ],
};

export const installationStepField = [
    {
        name: 'full_address',
        component: AddressAutoComplete,
        siblingField: [
            'zip',
            'locality',
            'state',
            'country_iso2',
            'lat',
            'lon',
        ],
        props: {
            label: 'Installation Address?',
            required: true,
        },
    },
    {
        name: 'how_many',
        dependOn: 'full_address',
        component: PeSingleChoice,
        props: {
            label: 'How many unit of Daikins ?',
            required: true,
            options: installOpt.how_many,
            sm: 1,
        },
    },
    {
        name: 'pe_installation',
        dependOn: 'how_many',
        component: PeSingleChoice,
        props: {
            label: 'Installation by PureElectric ?',
            required: true,
            options: installOpt.yes_no,
            sm: 2,
        },
    },
];